var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTwitch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.466 1 1.5 3.57v9.68h3.208V15h2.16l1.75-1.75h2.625l3.674-3.664V1H2.467zm1.659 1.458h9.333v6.417l-1.75 1.75h-3.5l-1.75 1.75v-1.75H4.125V2.458zM6.75 4.5v4.083H8.5V4.5H6.75zm2.917 0v4.083h1.75V4.5h-1.75z"
})));
export default SvgTwitch;